import React from 'react';
import { NavLink } from 'react-router-dom';
import { asset } from '../utils/asset';

const MobileFooter: React.FC = () => {

    return (
        <>
            {/* standard footer */}
            <footer className="adminuiux-mobile-footer hide-on-scrolldown style-2">
                <div className="container">
                    <ul className="nav nav-pills nav-justified bg-blur">
                        <li className="nav-item">
                            <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} to="/app/dashboard">
                                <span>
                                    <i className="nav-icon bi bi-columns-gap"></i>
                                    <span className="nav-text">Home</span>
                                </span>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} to="/app/job-portal">
                                <span>
                                    <i className="nav-icon bi bi-briefcase"></i>
                                    <span className="nav-text">Jobs</span>
                                </span>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} to="/app/company-profile">
                                <span>
                                    <i className="nav-icon bi bi-building"></i>
                                    <span className="nav-text">Company</span>
                                </span>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} to="/app/finance-dashboard">
                                <span>
                                    <i className="nav-icon bi bi-cash-stack"></i>
                                    <span className="nav-text">Finance</span>
                                </span>
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} to="/app/my-account">
                                <span>
                                    <figure className="avatar avatar-20 rounded-circle coverimg align-middle mb-2">
                                        <img src={asset('assets/img/adminuiux/user-6.jpg')} alt="" />
                                    </figure><br />
                                    <span className="nav-text">Profile</span>
                                </span>
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </footer>

        </>
    );
};

export default MobileFooter;
